import styled from '@emotion/styled'
import { CardFaqs } from '../CardFaqs'

const CardHeaderFaqs = styled(CardFaqs)`
  cursor: default;
  opacity: 1;
  border-radius: 8px;
  background-color: transparent;
  padding: 0px 19px;
  padding-right: 10%;
  width: 100%;
  gap: 22px;
  border: 1px solid transparent;
  &:hover {
    border: 1px solid transparent;
  }
  &:active {
    opacity: 1;
  }
  & img {
    width: 77px;
    height: 77px;
  }
  & .css-0 > {
    :nth-of-type(1) {
      font-size: 24px;
      font-weight: 600;
      line-height: 40px;
    }
    :nth-of-type(2) {
      font-size: 13px;
    }
  }
`

export default { CardHeaderFaqs }
